import { render, staticRenderFns } from "./ButtonGroupNew.vue?vue&type=template&id=49143ba7&scoped=true"
import script from "./ButtonGroupNew.vue?vue&type=script&lang=js"
export * from "./ButtonGroupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49143ba7",
  null
  
)

export default component.exports